export default function legacyClassModifier(classes: string): string {
    if (!classes || typeof classes !== 'string') return '';

    return classes
        .split(' ')
        .map((cssClass) => {
            if (!cssClass) return '';

            let modifiedClass = cssClass;
            if (!cssClass.startsWith('legacy:')) {
                modifiedClass = 'legacy:' + modifiedClass;
            }
            if (!cssClass.endsWith('!')) modifiedClass = modifiedClass + '!';

            return modifiedClass;
        })
        .filter(Boolean)
        .join(' ');
}
